import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { GenerateReportForm } from 'features/yieldbirdWrapperAgent/forms/GenerateReportForm'
import { MAX_URLS } from 'features/yieldbirdWrapperAgent/forms/GenerateReportForm/schema'

export const GenerateReportSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent', { keyPrefix: 'generate' })

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle', { count: MAX_URLS })}
        title={t('title')}
      />

      <GapBox />

      <GenerateReportForm />
    </Paper>
  )
}
